export interface RankItem {
  id: string;
  title: string;
  category: string;
  views: string;
  trend: string;
  cover: string;
}

export const hotRank: RankItem[] = [
  {
    id: "r01",
    title: "全网最治愈的出圈瞬间合集，一天一条刷不够",
    category: "治愈日常",
    views: "1302万",
    trend: "+120%",
    cover: "https://readdy.ai/api/search-image?query=a%20collage%20of%20heartwarming%20daily%20life%20moments%20with%20warm%20light%20and%20gentle%20colors%2C%20emotional%20short%20video%20highlight%20reel%2C%20cinematic%20frames&width=800&height=500&seq=rank-heal-01&orientation=landscape",
  },
  {
    id: "r02",
    title: "街头采访翻车名场面：年轻人一句话噎住全场主持",
    category: "出圈现场",
    views: "988万",
    trend: "+96%",
    cover: "https://readdy.ai/api/search-image?query=funny%20street%20interview%20reaction%20moment%20with%20microphone%2C%20surprised%20host%2C%20night%20street%20bokeh%2C%20comedy%20short%20video%20frame&width=800&height=500&seq=rank-live-02&orientation=landscape",
  },
  {
    id: "r03",
    title: "一分钟学会全网最火的手势舞，评论区纷纷交作业",
    category: "脑洞挑战",
    views: "821万",
    trend: "+75%",
    cover: "https://readdy.ai/api/search-image?query=young%20people%20practicing%20a%20viral%20hand%20gesture%20dance%2C%20bright%20studio%20lighting%2C%20energetic%20fun%20mood%2C%20challenge%20video%20frame&width=800&height=500&seq=rank-dance-03&orientation=landscape",
  },
  {
    id: "r04",
    title: "深夜蹲守终于拍到最想看的画面，网友：值了",
    category: "高能名场面",
    views: "766万",
    trend: "+61%",
    cover: "https://readdy.ai/api/search-image?query=photographer%20capturing%20a%20stunning%20moment%20in%20city%20at%20blue%20hour%2C%20exciting%20reveal%2C%20cinematic%20night%20scene%2C%20short%20video%20frame&width=800&height=500&seq=rank-night-04&orientation=landscape",
  },
  {
    id: "r05",
    title: "妈妈第一次看到孩子化妆的完整反应，笑着笑着就哭了",
    category: "治愈日常",
    views: "658万",
    trend: "+54%",
    cover: "https://readdy.ai/api/search-image?query=mother%20watching%20daughter%20getting%20dressed%20up%20with%20happy%20tears%2C%20warm%20family%20home%2C%20emotional%20tender%20moment%2C%20short%20video%20frame&width=800&height=500&seq=rank-mom-05&orientation=landscape",
  },
  {
    id: "r06",
    title: "用纸杯和胶带搭出的机械臂，网友直呼这是民间科学家",
    category: "脑洞挑战",
    views: "589万",
    trend: "+48%",
    cover: "https://readdy.ai/api/search-image?query=diy%20robotic%20arm%20made%20of%20paper%20cups%20and%20tape%2C%20creative%20maker%20working%20at%20a%20desk%2C%20curious%20inventive%20mood%2C%20short%20video%20frame&width=800&height=500&seq=rank-diy-06&orientation=landscape",
  },
];

export const hotTopics = [
  {
    id: "t01",
    tag: "话题",
    title: "#被一句话治愈的瞬间",
    desc: "你最近有没有被陌生人或身边人的一句话暖到？话题冲上热搜，评论区已成大型治愈现场。",
    reads: "2.4亿阅读",
    posts: "18.7万讨论",
    cover: "https://readdy.ai/api/search-image?query=soft%20warm%20abstract%20background%20with%20gentle%20glow%20and%20kind%20words%20theme%2C%20calming%20pastel%20tones%2C%20social%20topic%20banner&width=800&height=460&seq=topic-word-01&orientation=landscape",
  },
  {
    id: "t02",
    tag: "挑战",
    title: "#一分钟挑战全网神反转",
    desc: "用一分钟讲一个开头和结尾完全不同的故事，脑洞大开的投稿正在屠榜热门。",
    reads: "1.8亿阅读",
    posts: "12.3万讨论",
    cover: "https://readdy.ai/api/search-image?query=playful%20colorful%20abstract%20background%20with%20surprise%20twist%20theme%2C%20energetic%20challenge%20banner%2C%20vibrant%20gradient%20shapes&width=800&height=460&seq=topic-twist-02&orientation=landscape",
  },
  {
    id: "t03",
    tag: "名场面",
    title: "#刻进DNA的台词接龙",
    desc: "那些一看到就自动播放声音的经典台词，网友接力接龙根本停不下来，笑点密集。",
    reads: "1.2亿阅读",
    posts: "9.8万讨论",
    cover: "https://readdy.ai/api/search-image?query=retro%20cinema%20film%20strip%20abstract%20background%20with%20classic%20quotes%20theme%2C%20warm%20vintage%20tones%2C%20fun%20meme%20banner&width=800&height=460&seq=topic-meme-03&orientation=landscape",
  },
  {
    id: "t04",
    tag: "出圈",
    title: "#这座小城因一段视频出圈",
    desc: "一段旅行短视频带火一座小城，本地人集体出动，晒出真正的宝藏打卡地。",
    reads: "9800万阅读",
    posts: "6.4万讨论",
    cover: "https://readdy.ai/api/search-image?query=picturesque%20small%20chinese%20town%20with%20mountains%20and%20rivers%20in%20golden%20light%2C%20travel%20discovery%20topic%20banner%2C%20scenic%20wide%20view&width=800&height=460&seq=topic-town-04&orientation=landscape",
  },
];